import { render, staticRenderFns } from "./CompanyContractorDetailedInformation.vue?vue&type=template&id=2264e0aa&scoped=true"
import script from "./CompanyContractorDetailedInformation.vue?vue&type=script&lang=ts"
export * from "./CompanyContractorDetailedInformation.vue?vue&type=script&lang=ts"
import style0 from "./CompanyContractorDetailedInformation.vue?vue&type=style&index=0&id=2264e0aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264e0aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2264e0aa')) {
      api.createRecord('2264e0aa', component.options)
    } else {
      api.reload('2264e0aa', component.options)
    }
    module.hot.accept("./CompanyContractorDetailedInformation.vue?vue&type=template&id=2264e0aa&scoped=true", function () {
      api.rerender('2264e0aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/CompanyContractorDetailedInformation.vue"
export default component.exports